$(document).ready(function() {

  function equalHeightBtns(e) {
    var btnList = [],
      $this = $(e),
      id,
      init = function() {
        var maxHeight = 0;

        //find max height of buttons
        $.each(btnList, function(index, btn) {
          if ($(btn.this).height() > maxHeight) {
            maxHeight = $(btn.this).height();
          }
        });

        $.each(btnList, function(index, btn) {
          var maxPadding = (maxHeight - $(btn.this).height()) / 2,
            totalPaddingTop = btn.pTop + maxPadding,
            totalPaddingBottom = btn.pBottom + maxPadding;

          $(btn.this).css({
            "padding-top": totalPaddingTop,
            "padding-bottom": totalPaddingBottom
          })

        });

      }

    $this.find(".btn").each(function(index, data) {
      btnList.push({
        "this": data,
        "pTop": parseInt($(this).css("padding-top")),
        "pBottom": parseInt($(this).css("padding-bottom"))
      })
    });

    init();

    window.addEventListener('resize', function() {
      clearTimeout(id);
      id = setTimeout(init, 250);
    });

  }

  $('.btn-stack').each(function(index, data) {
    var equalBtns = new equalHeightBtns(data);
  })

})